import types from './mutation-types'

export default {
  reset() {},

  setSidebar({ commit }, sidebar) {
    commit(types.updateSidebar, sidebar)
  },

  setReferrer({ commit }, referrer) {
    commit(types.setReferrer, referrer)
  }
}
